/* globals angular */

var ngModule = angular.module('trends');

ngModule.directive('countrySelect', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope) {
            scope.countries = [
            'United Kingdom', 'United States', 'Afghanistan', 'Aland Islands',
            'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola',
            'Anguilla', 'Antartica', 'Antigua and Barbuda', 'Argentina', 
            'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan',
            'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
            'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda',
            'Bhutan', 'Bolivia, Plurinational State of', 
            'Bonaire, Sint Eustatius and Saba',
            'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island',
            'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam',
            'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon',
            'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic',
            'Chad', 'Chile', 'China', 'Christmas Island', 'Coco (Keeling) Islands',
            'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the',
            'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 
            'Cuba', 'Curacao', 'Cyprus', 'Czech Republic', 'Denmark', 
            'Dijbouti', 'Dominica', 'Dominican Republic', 'Ecuador', 
            'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 
            'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)',
            'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana',
            'French Polynesia', 'French Southern Territories', 'Gabon',
            'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 
            'Greenland', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 
            'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
            'Heard Island and McDonald Islands', 
            'Holy see (Vatican City State)', 'Honduras', 'Hong Kong', 
            'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic of', 
            'Iraq', 'Ireland', 'Isle of Man', 'Isreael', 'Italy', 
            'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 
            'Kenya', 'Kiribati', 'Korea, Democratic People\' Republic of', 
            'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 
            'Lao People\'s Democratic Republic', 'Latvia', 'Lebanon', 
            'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 
            'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 
            'Macedonia, The Former Yugoslav Republic of', 
            'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 
            'Marshall Islands', 'Martinique', 'Mauritania', 
            'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 
            'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 
            'Montserat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 
            'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 
            'Nicaraguya', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 
            'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 
            'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 
            'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 
            'Qatar', 'Reunion', 'Romania', 'Russian Federation', 
            'Rwanda', 'Saint Barthelemy',
            'Saint Helena, Ascension and Tristan de Cunha', 
            'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin (French part)', 
            'Saint Pierre and Miquelon', 'Saint Vincent and The Grenadines', 
            'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 
            'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 
            'Sint Maarten (Dutch part)', 'Slovakia', 'Slovenia', 'Solomon Islands',
            'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 
            'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 
            'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 
            'Syrian Arab Republic', 'Taiwan', 'Tajikistan',
            'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 
            'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 
            'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 
            'Uganda', 'Ukraine', 'United Arab Emirates', 
            'United States Minor Outlying Islands', 'Uruguay', 
            'Uzbekistan', 'Vanatu', 'Venezuela, Bolivarian Republic of', 
            'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S', 
            'Wallis and Futuna Islands', 'Western Sahara', 'Yemen', 
            'Zambia', 'Zimbabwe'

            ];
        }
    };
});
